import React, { useContext, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";
import '../css/menu.css';
import '../css/onprinttoggle.css';
import Image from 'react-bootstrap/Image';
import Logo from '../../margretlogo.png';

const Menu = () => {
    const location = useLocation();
    return (
        <div className="usr_menu print_hide">
            <br />
            <center><Image src={Logo} style={{ width: 80, height: 90 }} /></center>
            <center><h6>کارمەند</h6></center>
            <ul>
                <Link to="/employ/"><li className={location.pathname == '/employ/' ? 'aactive' : null}>لیستی کارمەند</li></Link>
                <Link to="/employ/employaccount"><li className={location.pathname == '/employ/employaccount' ? 'aactive' : null}>ژمێریاری کارمەند</li></Link>
                <Link to="/employ/report"><li className={location.pathname == '/employ/report' ? 'aactive' : null}>لیستی موچە</li></Link>
                <Link to="/employ/salarylistdetail"><li className={location.pathname == '/employ/salarylistdetail' ? 'aactive' : null}>وردەکاری لیستی موچە</li></Link>
            </ul>
        </div>
    )
}

export default Menu